import { Consortium, Centre } from '@cambridgeassessment/lib-ee-commons';
import { ConsortiaManagementState, seriesType } from '../../types/ConsortiaManagement';

export const FETCH_CENTRE = '@CONSORTIA_MANAGEMENT/FETCH_CENTRE';
export const SET_CENTRE = '@CONSORTIA_MANAGEMENT/SET_CENTRE';
export const SET_CONSORTIA = '@CONSORTIA_MANAGEMENT/SET_CONSORTIA';
export const SET_CONSORTIUM = '@CONSORTIA_MANAGEMENT/SET_CONSORTIUM';
export const SET_VALIDATION = '@CONSORTIA_MANAGEMENT/SET_VALIDATION';
export const SET_FETCHING_CONSORTIA = '@CONSORTIA_MANAGEMENT/SET_FETCHING_CONSORTIA';
export const SET_CONSORTIA_TOTAL = '@CONSORTIA_MANAGEMENT/SET_CONSORTIA_TOTAL';
export const SET_NEXT_PAGE_URL = '@CONSORTIA_MANAGEMENT/SET_NEXT_PAGE_URL';
export const SET_SEARCH_VALUE = '@CONSORTIA_MANAGEMENT/SET_SEARCH_VALUE';
export const SET_FILTER_VALUE = '@CONSORTIA_MANAGEMENT/SET_FILTER_VALUE';
export const SET_ERROR = '@CONSORTIA_MANAGEMENT/SET_ERROR';
export const SET_IS_LOADING = '@CONSORTIA_MANAGEMENT/SET_IS_LOADING';
export const SET_SUBMITTED_SUCCESSFULLY = '@CONSORTIA_MANAGEMENT/SET_SUBMITTED_SUCCESSFULLY';
export const RESET_STATE = '@CONSORTIA_MANAGEMENT/RESET_STATE';

export interface FetchCentre {
  type: typeof FETCH_CENTRE;
}

export interface SetCentre {
  type: typeof SET_CENTRE;
  payload: {
    centre: Centre;
  };
}
export interface SetConsortium {
  type: typeof SET_CONSORTIUM;
  payload: {
    consortium?: Consortium;
  };
}

export interface SetConsortia {
  type: typeof SET_CONSORTIA;
  payload: {
    consortia: Consortium[];
  };
}
export interface SetValidation {
  type: typeof SET_VALIDATION;
  payload: {
    validation: ConsortiaManagementState['validation'];
  };
}
export interface SetFetchingConsortia {
  type: typeof SET_FETCHING_CONSORTIA;
  payload: {
    value: boolean;
  };
}

export interface SetConsortiaTotal {
  type: typeof SET_CONSORTIA_TOTAL;
  payload: {
    count: number;
  };
}

export interface SetNextPageUrl {
  type: typeof SET_NEXT_PAGE_URL;
  payload: {
    url?: string;
  };
}

export interface SeatSearchValue {
  type: typeof SET_SEARCH_VALUE;
  payload: {
    value?: string;
  };
}

export interface SetFilterValue {
  type: typeof SET_FILTER_VALUE;
  payload: {
    value: seriesType;
  };
}

export interface SetIsLoading {
  type: typeof SET_IS_LOADING;
  payload: {
    isLoading: boolean;
  };
}
export interface SetIsSubmittedSuccessfully {
  type: typeof SET_SUBMITTED_SUCCESSFULLY;
  payload: {
    value: boolean;
  };
}
export interface SetError {
  type: typeof SET_ERROR;
}

export interface ResetState {
  type: typeof RESET_STATE;
}

export type ConsortiaManagementTypes =
  | SetIsLoading
  | SetIsSubmittedSuccessfully
  | SetError
  | FetchCentre
  | SetCentre
  | SetConsortium
  | SetConsortia
  | SetValidation
  | SetFetchingConsortia
  | SetConsortiaTotal
  | SetFilterValue
  | SetNextPageUrl
  | SeatSearchValue
  | ResetState;
